import React, { useState } from 'react';
import { DesktopPreview } from './components/DesktopPreview';
import { HeaderPreview } from './components/HeaderPreview';
import { MobilePreview } from './components/MobilePreview';
import { Layout } from './customization-preview.styles';

export const CustomizationPreview = () => {
  const [previewDesktop, setPreviewDesktop] = useState<boolean>(true);

  const onChangePreview = (isDesktop: boolean) => {
    setPreviewDesktop(isDesktop);
  };

  return (
    <Layout>
      <HeaderPreview onChange={onChangePreview} isPreviewDesktop={previewDesktop} />
      {previewDesktop ? <DesktopPreview /> : <MobilePreview />}
    </Layout>
  );
};

CustomizationPreview.displayName = 'CustomizationPreview';
